import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

export default function AppStepper({customSteps,activeStep}) {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep || 0} alternativeLabel>
        {customSteps.map((label) => (
          <Step key={label}>
            <StepLabel >{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}